const CALIFADVENTURELANDS = [
    {
        name: 'Avengers Campus',
        rides: [
            {
                name: 'Guardians of the Galaxy - Mission: BREAKOUT!',
                count: 0
            },
            {
                name: 'WEB SLINGERS: A Spider-Man Adventure',
                count: 0
            }
        ]
    },
    {
        name: 'Buena Vista Street',
        rides: [
            {
                name: 'Red Car Trolley',
                count: 0,
            }
        ]
    },
    {
        name: 'Cars Land',
        rides: [
            {
                name: "Luigi's Rollickin' Roadsters",
                count: 0,
            },
            {
                name: "Mater's Junkyard Jamboree",
                count: 0,
            },
            {
                name: "Radiator Springs Racers",
                count: 0,
            }
        ]
    },
    {
        name: 'Grizzly Peak',
        rides: [
            {
                name: 'Grizzly River Run',
                count: 0,
            },
            {
                name: 'Redwood Creek Challenge',
                count: 0,
            },
            {
                name: "Soarin' Around the World",
                count: 0,
            }
        ]
    },
    {
        name: 'Hollywood Land',
        rides: [
            {
                name: 'Animation Academy',
                count: 0,
            },
            {
                name: 'Monsters, Inc. Mike & Sulley to the Rescue!',
                count: 0,
            },
            {
                name: "Sorcerer's Workshop",
                count: 0,
            }
        ]
    },
    {
        name: 'Paradise Gardens Park',
        rides: [
            {
                name: 'Golden Zephyr',
                count: 0,
            },
            {
                name: "Goofy's Sky School",
                count: 0,
            },
            {
                name: "Jumpin' Jellyfish",
                count: 0,
            },
            {
                name: 'Silly Symphony Swings',
                count: 0,
            },
            {
                name: "The Little Mermaid - Ariel's Undersea Adventure",
                count: 0,
            },
            {
                name: "World of Color",
                count: 0,
            }
        ]
    },
    {
        name: 'Pixar Pier',
        rides: [
            {
                name: 'Pixar Pal-A-Round',
                count: 0,
            },
            {
                name: 'Toy Story Midway Mania!',
                count: 0,
            }
        ]
    }
]

export default CALIFADVENTURELANDS;